
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"oeamtc-icon__motorway","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.5 13.5a.5.5 0 011 0v.5H13L10.5 1h-2v.5a.5.5 0 01-1 0V1h-2L3 14h4.5zm0-9.75a.5.5 0 011 0v1a.5.5 0 01-1 0zM7.5 7a.5.5 0 011 0v1a.5.5 0 01-1 0zm0 3.25a.5.5 0 011 0v1a.5.5 0 01-1 0z"}})])
          )
        }
      }
    